import React from 'react';
import { observer } from 'mobx-react';

import { FormWrapper, FieldsWrapper } from 'libs/forms/styles';
import { confToFields } from 'libs/forms';
import { Button, Box } from 'components';

import { Section } from 'apps/shared/layout';
import { CostList } from './CostList';
import CreateShipmentQuoteAppManager from '../appManager';

interface ShipmentSummaryProps {
  shipmentQuoteAppManager: CreateShipmentQuoteAppManager;
}

export const ShipmentSummary = observer(
  ({ shipmentQuoteAppManager }: ShipmentSummaryProps) => {
    const { shipmentQuoteFormStore, shipmentQuoteApp } =
      shipmentQuoteAppManager;
    return (
      <Section>
        <FormWrapper ml={0} responsive>
          <Box mb={8} sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <CostList shipmentQuoteAppManager={shipmentQuoteAppManager} />
            <Box sx={{ width: '40%' }}>
              <FieldsWrapper responsive>
                {confToFields({
                  formStore: shipmentQuoteFormStore,
                  refs: {},
                  responsive: true,
                  fields: ['notes'],
                })}
              </FieldsWrapper>
            </Box>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <FieldsWrapper responsive>
              {confToFields({
                formStore: shipmentQuoteFormStore,
                refs: {},
                responsive: true,
                fields: ['isOrder'],
              })}
            </FieldsWrapper>
          </Box>
          <Box sx={{ display: 'flex', marginBottom: '2rem' }}>
            <Button
              data-testid='submit-multi-quote-button'
              margin='0 auto'
              type='submit'
              outline
              size='small'
              loading={shipmentQuoteApp.submitting}
              text='Send Quote to Customer'
              onClick={e => {
                shipmentQuoteAppManager.Submit();
                e.preventDefault();
              }}
            />
          </Box>
        </FormWrapper>
      </Section>
    );
  },
);
